import React from 'react'

import {
    Text
} from "@chakra-ui/react";

function WelcomeEmail() {
    let email = "";
    let user = localStorage.getItem("user");
    if (user) {
      email =
        JSON.parse(user).user && JSON.parse(user).user.email
          ? JSON.parse(user).user.email
          : "User";
    }
    return (
        <>
           <Text fontSize="12px" color="#2c7a7b">
                Welcome {email}
            </Text>  
        </>
    )
}

export default WelcomeEmail
